// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 改变主题色变量 */\n#app .el-button {\n  font-weight: 400;\n  border-radius: 4px;\n}", ""]);
// Exports
exports.locals = {
	"colorPrimary": "#1890ff"
};
module.exports = exports;
